export default __webpack_public_path__ + "static/media/QK_9196.dfd77690.jpg";